// extracted by mini-css-extract-plugin
export default {"referral":"congratulation_referral__vh+8t","btnHolder":"congratulation_btnHolder__iD4hC","backHome":"congratulation_backHome__rYgx5"};